import { PackageData } from '@amzn/awsdev-docs-virtual-smiley-typescript-client';

const SOURCE_LOCALES = new Set(['english', 'en_us', 'en-us']);

const isSourceLocale = (locale: string): boolean =>
  SOURCE_LOCALES.has(locale.toLowerCase());

const getGuideLocale = (guide: unknown): string | undefined => {
  if (typeof guide !== 'object' || guide === null || !('locale' in guide)) {
    return undefined;
  }

  const locale = (guide as { locale?: unknown }).locale;
  return typeof locale === 'string' ? locale.trim() || undefined : undefined;
};

export const getLocalizedPackageLocale = (
  packageData: PackageData
): string | undefined => {
  const explicitLocale = packageData.locale?.trim();
  if (explicitLocale) {
    return isSourceLocale(explicitLocale) ? undefined : explicitLocale;
  }

  if (!packageData.guides) {
    return undefined;
  }

  try {
    const guides = Object.values(
      JSON.parse(packageData.guides) as Record<string, unknown>
    );

    return guides
      .map(getGuideLocale)
      .find((locale): locale is string =>
        Boolean(locale && !isSourceLocale(locale))
      );
  } catch {
    return undefined;
  }
};
